/* src/app/modules/shared/components/sidebar/sidebar.component.scss */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: #073b70;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease, transform 0.3s ease;
  overflow: hidden;
}
.sidebar.collapsed {
  transform: translateX(-100%);
  visibility: hidden;
}
.sidebar .sidebar-content {
  height: 100%;
  overflow-y: auto;
}
.sidebar ul.nav {
  padding: 0;
  margin: 0;
  list-style: none;
  flex-grow: 1;
}
.sidebar ul.nav li.nav-item .menu-item {
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #ffffff;
  transition: background-color 0.3s;
}
.sidebar ul.nav li.nav-item .menu-item:hover {
  background-color: #495057;
}
.sidebar ul.nav li.nav-item .submenu-toggle {
  margin-left: auto;
}
/*# sourceMappingURL=sidebar.component.css.map */
